module.exports = __webpack_public_path__ + "img/photo-01.dc1f2220.png";